/**
 * "Compliant"/"Not Compliant" is a render-layer label over `compliance_b`'s stored result
 * (reuses the existing Rating Scale + Not Applicable Rating toggle, no new Rating Scale — spec
 * decision #3). Anything other than very_good/very_poor, including the null the app writes for
 * "Not Applicable", is "Not Applicable" (QA 108.02 item 6: was "N/A"; the API's
 * SdaComplianceTableService still emits "N/A" for the Word export — raytd/api#146, so the two
 * labels differ until that lands). The Compliant/Not Compliant labels still mirror
 * SdaComplianceTableService::RESULT_LABELS.
 */
const SDA_RESULT_LABELS: Record<string, string> = {
  very_good: 'Compliant',
  very_poor: 'Not Compliant',
};

export default function mapSdaComplianceResult(result: string | null | undefined): string {
  return (result && SDA_RESULT_LABELS[result]) || 'Not Applicable';
}
